/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Day/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Day({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/InstallmentDates/SelectedInstallmentInterval/Days/Day"
  
}) {
let newPaymentPlanSelectedInstallmentDate0ValueData = fromData.useDataValue({ viewPath,
context: 'new_payment_plan',
path: 'selected_installment_date.0',
})
let dayIdValueData = fromData.useDataValue({ viewPath,
context: 'day',
path: 'id',
})
let aggregateData = fromAggregate.equals(newPaymentPlanSelectedInstallmentDate0ValueData, dayIdValueData)
let dayTextValueData = fromData.useDataValue({ viewPath,
context: 'day',
path: 'text',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="new_payment_plan.selected_installment_date.0"
 data="day.id"
 aggregate="/Simple/Data/aggregate.js equals"
 isSelected={aggregateData}
 data="day.text"
 text={dayTextValueData}
 onClick={onClick}
/>
{children}
</React.Fragment>)
}